import {HttpService} from "./HttpService";

class ProductService {
    getProducts() {
        return new Promise((resolve, reject) => {
            HttpService
                .createWithoutAuthorization()
                .get(`/api/products`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }
}

const svc = new ProductService();

export default svc;
